import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_9 = { class: "required" }
const _hoisted_10 = { class: "col-lg-8 fv-row" }
const _hoisted_11 = ["label"]
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "required" }
const _hoisted_18 = { class: "col-lg-8 fv-row" }
const _hoisted_19 = ["label"]
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_25 = { class: "col-lg-8 fv-row" }
const _hoisted_26 = ["label"]
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "row mb-6" }
const _hoisted_31 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_32 = { class: "col-lg-8 fv-row" }
const _hoisted_33 = { class: "row mb-6" }
const _hoisted_34 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_35 = { class: "col-lg-8 fv-row" }
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "row mb-6" }
const _hoisted_39 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_40 = { class: "required" }
const _hoisted_41 = ["title"]
const _hoisted_42 = { class: "col-lg-8 fv-row" }
const _hoisted_43 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_44 = ["value"]
const _hoisted_45 = { class: "fv-plugins-message-container" }
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = { class: "row mb-6" }
const _hoisted_48 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_49 = { class: "col-lg-8 fv-row" }
const _hoisted_50 = { class: "fv-plugins-message-container" }
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = { class: "row mb-6" }
const _hoisted_53 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_54 = { class: "col-lg-8 fv-row" }
const _hoisted_55 = { class: "fv-plugins-message-container" }
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = { class: "row mb-6" }
const _hoisted_58 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_59 = { class: "col-lg-8 fv-row" }
const _hoisted_60 = { class: "fv-plugins-message-container" }
const _hoisted_61 = { class: "fv-help-block" }
const _hoisted_62 = { class: "row mb-6" }
const _hoisted_63 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_64 = { class: "col-lg-8 fv-row" }
const _hoisted_65 = { class: "fv-plugins-message-container" }
const _hoisted_66 = { class: "fv-help-block" }
const _hoisted_67 = { class: "row mb-6" }
const _hoisted_68 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_69 = { class: "col-lg-8 fv-row" }
const _hoisted_70 = { class: "fv-plugins-message-container" }
const _hoisted_71 = { class: "fv-help-block" }
const _hoisted_72 = { class: "row mb-6" }
const _hoisted_73 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_74 = { class: "col-lg-8 fv-row" }
const _hoisted_75 = { class: "fv-plugins-message-container" }
const _hoisted_76 = { class: "fv-help-block" }
const _hoisted_77 = { class: "row mb-6" }
const _hoisted_78 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_79 = { class: "col-lg-8" }
const _hoisted_80 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true"
}
const _hoisted_81 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change image"
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle-fill fs-6" }, null, -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "avatar_create"
}, null, -1)
const _hoisted_84 = { class: "fv-plugins-message-container" }
const _hoisted_85 = { class: "fv-help-block" }
const _hoisted_86 = { class: "form-text" }
const _hoisted_87 = { class: "row mb-6" }
const _hoisted_88 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_89 = { class: "col-lg-8" }
const _hoisted_90 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true"
}
const _hoisted_91 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change image"
}
const _hoisted_92 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle-fill fs-6" }, null, -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "avatar_create"
}, null, -1)
const _hoisted_94 = { class: "fv-plugins-message-container" }
const _hoisted_95 = { class: "fv-help-block" }
const _hoisted_96 = { class: "form-text" }
const _hoisted_97 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_98 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_99 = { class: "col-lg-8 fv-row" }
const _hoisted_100 = { class: "fv-plugins-message-container" }
const _hoisted_101 = { class: "fv-help-block" }
const _hoisted_102 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_103 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_104 = { class: "col-lg-8 fv-row" }
const _hoisted_105 = { class: "fv-plugins-message-container" }
const _hoisted_106 = { class: "fv-help-block" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-8" }, null, -1)
const _hoisted_108 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_109 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_110 = { class: "indicator-label" }
const _hoisted_111 = { class: "indicator-progress" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_DeeplinkBuilder = _resolveComponent("DeeplinkBuilder")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'settings'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewBanners')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.bannerSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.translate('bannerType')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "type",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedBanner,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedBanner) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", {
                          disabled: "",
                          selected: "",
                          label: _ctx.translate('selectBannerType')
                        }, null, 8, _hoisted_11),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannersAssets.typeBanners, (typeBanner) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: typeBanner.id,
                            value: typeBanner.id
                          }, _toDisplayString(typeBanner.title), 9, _hoisted_12))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_ErrorMessage, { name: "type" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.translate('bannerLocation')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "screen",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedScreen,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedScreen) = $event)),
                      onChange: _ctx.ScreenBannerOnChange
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", {
                          disabled: "",
                          selected: "",
                          label: _ctx.translate('SelectScreen')
                        }, null, 8, _hoisted_19),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannersAssets.scrrens, (scrren) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: scrren.id,
                            value: scrren.id
                          }, _toDisplayString(scrren.title), 9, _hoisted_20))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_ErrorMessage, { name: "screen" })
                      ])
                    ])
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", _hoisted_24, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.translate('bannerAction')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "slug",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedSlug,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedSlug) = $event)),
                      onChange: _ctx.ActionBannerOnChange
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", {
                          disabled: "",
                          selected: "",
                          label: _ctx.translate('selectDirection')
                        }, null, 8, _hoisted_26),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannersAssets.typeSlug, (slug) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: slug.id,
                            value: slug.id
                          }, _toDisplayString(slug.title), 9, _hoisted_27))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_ErrorMessage, { name: "slug" })
                      ])
                    ])
                  ])
                ], 512), [
                  [_vShow, _ctx.selectedBanner === 'internal']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_30, [
                  _createElementVNode("label", _hoisted_31, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.translate('merchant')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_Multiselect, {
                      ref: "multiselect",
                      modelValue: _ctx.selectedMerchant,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedMerchant) = $event)),
                      options: _ctx.merchants,
                      "close-on-select": true,
                      loading: _ctx.loading,
                      searchable: true,
                      trackBy: "name",
                      canDeselect: false,
                      placeholder: _ctx.translate('selectMerchant'),
                      valueProp: "id",
                      label: "name",
                      noResultsText: _ctx.translate('noResultsFound')
                    }, null, 8, ["modelValue", "options", "loading", "placeholder", "noResultsText"])
                  ])
                ], 512), [
                  [_vShow, 
              _ctx.selectedSlug === 'merchant' &&
              _ctx.selectedBanner === 'internal' &&
              _ctx.isRelatedId
            ]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_33, [
                  _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.translate('entityId')) + ": ", 1),
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "entityId",
                      autocomplete: "off",
                      min: "1",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('entityId')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_ErrorMessage, { name: "entityId" })
                      ])
                    ])
                  ])
                ], 512), [
                  [_vShow, 
              _ctx.selectedSlug !== 'merchant' &&
              _ctx.selectedBanner === 'internal' &&
              _ctx.isRelatedId
            ]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_38, [
                  _createElementVNode("label", _hoisted_39, [
                    _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.translate('propertyCategory')), 1),
                    _createElementVNode("i", {
                      class: "fas fa-exclamation-circle ms-1 fs-7",
                      "data-bs-toggle": "tooltip",
                      title: _ctx.translate('propertyCategoryTooltip')
                    }, null, 8, _hoisted_41)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "propertyCategoryId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedPropertyCategory,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedPropertyCategory) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_43, _toDisplayString(_ctx.translate('selectPropertyCategory')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertyTypesCategories, (propertyCategory) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: propertyCategory.id,
                            value: propertyCategory.id
                          }, _toDisplayString(propertyCategory.title), 9, _hoisted_44))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_ErrorMessage, { name: "propertyCategoryId" })
                      ])
                    ])
                  ])
                ], 512), [
                  [_vShow, _ctx.selectedScreen === 'ad']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_47, [
                  _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.translate('AdPriceFrom')) + ": ", 1),
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "adPriceFrom",
                      autocomplete: "off",
                      min: "1",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('AdPriceFrom')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_ErrorMessage, { name: "adPriceFrom" })
                      ])
                    ])
                  ])
                ], 512), [
                  [_vShow, _ctx.selectedScreen === 'ad']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_52, [
                  _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.translate('AdPriceTo')) + ": ", 1),
                  _createElementVNode("div", _hoisted_54, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "adPriceTo",
                      autocomplete: "off",
                      min: "1",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('AdPriceTo')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createVNode(_component_ErrorMessage, { name: "adPriceTo" })
                      ])
                    ])
                  ])
                ], 512), [
                  [_vShow, _ctx.selectedScreen === 'ad']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_57, [
                  _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.translate('externalLinkEn')) + ": ", 1),
                  _createElementVNode("div", _hoisted_59, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "externalLinkEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('bannerUrlEn')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createVNode(_component_ErrorMessage, { name: "externalLinkEn" })
                      ])
                    ])
                  ])
                ], 512), [
                  [_vShow, _ctx.selectedBanner == 'external']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_62, [
                  _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.translate('externalLinkAr')) + ": ", 1),
                  _createElementVNode("div", _hoisted_64, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "externalLinkAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('bannerUrlAr')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", _hoisted_66, [
                        _createVNode(_component_ErrorMessage, { name: "externalLinkAr" })
                      ])
                    ])
                  ])
                ], 512), [
                  [_vShow, _ctx.selectedBanner == 'external']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_67, [
                  _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.translate('externalLinkWebEn')) + ": ", 1),
                  _createElementVNode("div", _hoisted_69, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "externalLinkWebEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('bannerUrlWebEn')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _createVNode(_component_ErrorMessage, { name: "externalLinkWebEn" })
                      ])
                    ])
                  ])
                ], 512), [
                  [_vShow, _ctx.selectedBanner == 'external']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_72, [
                  _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.translate('externalLinkWebAr')) + ": ", 1),
                  _createElementVNode("div", _hoisted_74, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "externalLinkWebAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('bannerUrlWebAr')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _createVNode(_component_ErrorMessage, { name: "externalLinkWebAr" })
                      ])
                    ])
                  ])
                ], 512), [
                  [_vShow, _ctx.selectedBanner == 'external']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_77, [
                  _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.translate('bannerImage')), 1),
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("div", {
                        class: "image-input-wrapper w-125px h-125px",
                        style: _normalizeStyle(`background-image: url(${_ctx.thumbnail})`)
                      }, null, 4),
                      _createElementVNode("label", _hoisted_81, [
                        _hoisted_82,
                        _createVNode(_component_Field, {
                          type: "file",
                          name: "logo",
                          accept: ".png, .jpg, .jpeg",
                          onChange: _ctx.previewImage
                        }, null, 8, ["onChange"]),
                        _hoisted_83
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                      _createElementVNode("div", _hoisted_85, [
                        _createVNode(_component_ErrorMessage, { name: "logo" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.translate('allowedFileTypes')), 1)
                  ])
                ], 512), [
                  [_vShow, _ctx.selectedScreen !== 'ad']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_87, [
                  _createElementVNode("label", _hoisted_88, _toDisplayString(_ctx.translate('bannerImageWeb')), 1),
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("div", {
                        class: "image-input-wrapper w-125px h-125px",
                        style: _normalizeStyle(`background-image: url(${_ctx.thumbnailWeb})`)
                      }, null, 4),
                      _createElementVNode("label", _hoisted_91, [
                        _hoisted_92,
                        _createVNode(_component_Field, {
                          type: "file",
                          name: "logoWeb",
                          accept: ".png, .jpg, .jpeg",
                          onChange: _ctx.previewImageWeb
                        }, null, 8, ["onChange"]),
                        _hoisted_93
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("div", _hoisted_95, [
                        _createVNode(_component_ErrorMessage, { name: "logoWeb" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_96, _toDisplayString(_ctx.translate('allowedFileTypes')), 1)
                  ])
                ], 512), [
                  [_vShow, _ctx.selectedScreen !== 'ad']
                ]),
                (_ctx.selectedScreen == 'home-services')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                      _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.translate('arabicName')), 1),
                      _createElementVNode("div", _hoisted_99, [
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "titleAr",
                          autocomplete: "off",
                          class: "form-control form-control-lg form-control-solid",
                          placeholder: _ctx.translate('areaNameArLang')
                        }, null, 8, ["placeholder"]),
                        _createElementVNode("div", _hoisted_100, [
                          _createElementVNode("div", _hoisted_101, [
                            _createVNode(_component_ErrorMessage, { name: "titleAr" })
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedScreen == 'home-services')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                      _createElementVNode("label", _hoisted_103, _toDisplayString(_ctx.translate('englishName')), 1),
                      _createElementVNode("div", _hoisted_104, [
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "titleEn",
                          autocomplete: "off",
                          class: "form-control form-control-lg form-control-solid",
                          placeholder: _ctx.translate('areaNameEnLang')
                        }, null, 8, ["placeholder"]),
                        _createElementVNode("div", _hoisted_105, [
                          _createElementVNode("div", _hoisted_106, [
                            _createVNode(_component_ErrorMessage, { name: "titleEn" })
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_107,
                _createVNode(_component_DeeplinkBuilder, {
                  ref: "deeplinkBuilder",
                  modelValue: _ctx.deeplink,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.deeplink) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_108, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_109, [
                  _createElementVNode("span", _hoisted_110, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_111, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_112
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}